import styled from '@emotion/styled';
import Icon from '@icon/Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const CheckboxChecked = (props) => {
  const { color, fill, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon viewBox="0 0 24 24" {...rest}>
      <rect x="2" y="2" width="20" height="20" rx="4" fill={color} />
      <path
        d="M11.04 13.4655L8.947 11.157C8.69119 10.8749 8.26881 10.8749 8.013 11.157C7.76604 11.4294 7.76604 11.8647 8.013 12.1371L10.573 14.9606C10.8288 15.2428 11.2512 15.2428 11.507 14.9606L15.987 10.0194C16.234 9.74706 16.234 9.31177 15.987 9.03938C15.7312 8.75724 15.3088 8.75724 15.053 9.03938L11.04 13.4655Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.344444"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

export default CheckboxChecked;
